<template>
  <div class="noticeWarp">
    <div class="close" @click="closeMenu">×</div>
    <img :src="imgUrl" />
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },

  props: ['imgUrl'],

  methods: {
    hasRead() {
      this.$parent.hasRead()
    },
    closeMenu() {
      this.$parent.showTemp = false
      console.log('触发了')
    },

  },
  mounted() {

  },
  created() {
    // window.addEventListener('popstate', function (event) {
    //   location.replace(window.location.href)
    //   this.$parent.showTemp = false
    // });
    if (this.$parent.showTemp) {
      history.pushState(null, null, document.URL)
      window.addEventListener(
        'popstate',
        () => {
          // 在这个可以添加条件判断
          console.log(this.$parent.showTemp)
          this.$parent.showTemp = false
          console.log(12345)
        },
        false
      )
    }


  },

  computed: {

  }
}
</script>

<style scoped lang="scss">
.noticeWarp {
  padding: 5%;
  position: fixed;
  top: 0;
  height: 95%;
  background-color: #000;
  overflow: scroll;
  text-align: left;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-left: 0;

  .close {
    position: absolute;
    left: 15px;
    top: 15px;
    color: #fff;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid #fff;
    text-align: center;
    line-height: 30px;
  }

  img {
    transform: translateX(5px);
    width: 100%;
    height: auto;
  }

}

.pcNoticeWarp {
  padding: 0.2rem 5%;

  .noticeDetail {
    font-size: 0.3rem;
  }

  .contentTitle {
    margin-bottom: 0.2rem;
    font-size: 0.35rem;
  }

  .buttonConfirm {
    font-size: 0.3rem;
    width: 1.5rem;
    height: 0.5rem;
    line-height: 0.5rem;
    margin-top: 0.2rem;
  }
}
</style>
